import { render, staticRenderFns } from "./AddressList.vue?vue&type=template&id=390a87a1&scoped=true&"
import script from "./AddressList.vue?vue&type=script&lang=js&"
export * from "./AddressList.vue?vue&type=script&lang=js&"
import style0 from "./AddressList.vue?vue&type=style&index=0&id=390a87a1&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "390a87a1",
  null
  
)

export default component.exports